import {apiGetCapitals} from "api/reportApi";
import {PriceComponentColored} from "components/Table/CellComponents";
import {formatPrice} from "../helpers";

const capitalColumns = [
    {
        name: "شرح",
        key: "description",
        size: "17",
    },
    {
        name: "مبلغ",
        key: "amount",
        // @ts-ignore
        getValue: (item) => {
            return formatPrice(parseInt(item.amount));
        },
        Component: PriceComponentColored,
        size: "5",
        searchType: "quantitative",
    },
    {
        name: "تاریخ",
        key: "date",
        size: "5",
        showDatePicker: true,
        searchType: "date",
    },
];

export const capitalIndexData = [
    {
        key: "capital",
        label: "صورتحساب سرمایه",
        pluralLabel: "صورتحساب سرمایه",
        title: "مشصورتحساب سرمایه",
        pageTitle: "صورتحساب سرمایه",
        // pageDescription: "نمایش صورتحساب سرمایه کسب و کار",
        tableColumns: capitalColumns,
        disableSearch: true,
        actions: {
            back: {},
            fetch: apiGetCapitals,
            // excel: {},
        },
    },
];
